import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { formatCurrency } from '@/helpers/format/formatCurrency';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
var APARTMENT_SUBTYPES;
(function (APARTMENT_SUBTYPES) {
    APARTMENT_SUBTYPES["T1"] = "1";
    APARTMENT_SUBTYPES["T2"] = "2";
    APARTMENT_SUBTYPES["T3"] = "3";
    APARTMENT_SUBTYPES["T4"] = "4";
    APARTMENT_SUBTYPES["T5"] = "5";
})(APARTMENT_SUBTYPES || (APARTMENT_SUBTYPES = {}));
var HOUSE_SUBTYPES;
(function (HOUSE_SUBTYPES) {
    HOUSE_SUBTYPES["DETACHED"] = "detachedHouse";
    HOUSE_SUBTYPES["MID_TERRACE"] = "terracedHouse";
    HOUSE_SUBTYPES["SEMI_DETACHED"] = "semiDetachedHouse";
})(HOUSE_SUBTYPES || (HOUSE_SUBTYPES = {}));
const PriceTable = ({ title, headerTitles, data, getLabel, language }) => (_jsxs(Box, { marginBottom: "spacing.32", children: [_jsx(Box, { as: "h2", typography: "typography.headline.20.bold", marginBottom: "spacing.16", children: title }), _jsxs(Box, { as: "table", width: "100%", children: [_jsx(Box, { as: "thead", borderBottomWidth: "borderWidth.1", borderBottomStyle: "solid", borderColor: "color.border.surface.default", children: _jsxs(Box, { as: "tr", children: [_jsx(Box, { as: "th", paddingVertical: "spacing.16", textAlign: "left", typography: "typography.body.14.bold", children: headerTitles.subtype }), _jsx(Box, { as: "th", paddingVertical: "spacing.16", textAlign: "end", typography: "typography.body.14.bold", children: headerTitles.price })] }) }), _jsx(Box, { as: "tbody", children: Object.entries(data).map(([key, value]) => (_jsxs(Box, { as: "tr", borderBottomWidth: "borderWidth.1", borderBottomStyle: "solid", borderColor: "color.border.surface.default", children: [_jsx(Box, { as: "td", paddingVertical: "spacing.16", typography: "typography.body.16.regular", children: getLabel(key) }), _jsx(Box, { as: "td", paddingVertical: "spacing.16", textAlign: "end", typography: "typography.body.16.regular", color: "color.content.light.default", children: formatCurrency(value, language) })] }, key))) })] })] }));
export const PriceTableBySubtype = ({ price, place }) => {
    const { t } = useShellTranslation();
    const { language } = useLocale();
    const apartmentData = price?.sell?.apartment?.item_subtype_price;
    const houseData = price?.sell?.house?.item_subtype_price;
    const hasApartmentData = apartmentData && Object.keys(apartmentData).length > 0;
    const hasHouseData = houseData && Object.keys(houseData).length > 0;
    if (!hasApartmentData && !hasHouseData) {
        return null;
    }
    return (_jsxs(Box, { children: [hasApartmentData && (_jsx(PriceTable, { title: t('price_table_block.info_view.table_number_of_rooms_title', {
                    replace: { place: place?.name.full || '' },
                }), headerTitles: {
                    subtype: t('price_table_block.info_view.sheet_numberOfRooms_title'),
                    price: t('link_boxes.sheet_title_prices'),
                }, data: apartmentData, getLabel: (key) => APARTMENT_SUBTYPES[key] || key, language: language })), hasHouseData && (_jsx(PriceTable, { title: t('price_table_block.info_view.table_houseType_title', {
                    replace: { place: place?.name.full || '' },
                }), headerTitles: {
                    subtype: t('price_table_block.info_view.sheet_houseType_title'),
                    price: t('link_boxes.sheet_title_prices'),
                }, data: houseData, getLabel: (key) => {
                    const subtype = HOUSE_SUBTYPES[key];
                    return subtype
                        ? t(`price_table_block.info_view.table_houseType.${subtype}`)
                        : key;
                }, language: language }))] }));
};
